import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, trackPageView } from './lib/meta-pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <LandingPage data-id="element-0" />;
}